import type { Brand } from "@/utils/theme/brand";

import { ADMIN_SHELL } from "./admin/shell";
import type { BrandShellConfig } from "./base/BrandShell";
import { GUESTMAKER_SHELL } from "./guestmaker/shell";
import { WIFIBOT_SHELL } from "./wifibot/shell";

/** Every product's login shell, keyed by the brand the theme engine stamps. */
export const BRAND_SHELLS: Record<Brand, BrandShellConfig> = {
  guestmaker: GUESTMAKER_SHELL,
  wifibot: WIFIBOT_SHELL,
  admin: ADMIN_SHELL,
};
